import moment, { Moment } from 'moment-timezone';

import { PaymentDateOptionsDto } from '@alpha/payments-dtos';

const isAfterMigrationDate = (
  formattedDate: string,
  corpayMigrationStartDate?: string,
): boolean => {
  const migrationDate = corpayMigrationStartDate
    ? moment(corpayMigrationStartDate).format('YYYY-MM-DD')
    : undefined;

  return migrationDate
    ? moment(formattedDate).isAfter(migrationDate)
      || (moment(formattedDate).isSame(migrationDate)
        && moment.tz('Europe/London').isAfter(moment.tz(corpayMigrationStartDate, 'Europe/London')))
    : false;
};

const calculateDisablePaymentDates = (
  _date: Moment,
  dateOptions?: PaymentDateOptionsDto,
  corpayMigrationEndDate?: string,
): boolean => {
  const defaultTimezone = moment.tz.guess();
  const formattedDate = _date.tz(defaultTimezone).format('YYYY-MM-DD');

  const isAfterMigrationCutOff = !!corpayMigrationEndDate
    && isAfterMigrationDate(formattedDate, moment(corpayMigrationEndDate).subtract(3, 'days').format('YYYY-MM-DD'));

  if (dateOptions) {
    const todayDate = moment.tz('Europe/London').format('YYYY-MM-DD');

    const notHolidays = dateOptions.holidays.some((holiday) => moment(holiday.date).tz('Europe/London').format('YYYY-MM-DD') === formattedDate);
    _date.tz(defaultTimezone);

    return (
      moment(formattedDate).isBefore(todayDate)
      || moment(formattedDate).isBefore(dateOptions.earliestDate)
      || moment(formattedDate).isAfter(dateOptions.latestDate)
      || notHolidays
      || isAfterMigrationCutOff
    );
  }

  return isAfterMigrationCutOff;
};

export default calculateDisablePaymentDates;
